export default __webpack_public_path__ + "static/media/tent&midi_d_ossau.502a393f.jpg";